import { AUTH_MODE, keycloakAuthService } from '@/auth/keycloak'
import { logout as legacyLogout } from '@/app-store/user/authSlice'
import { store } from '@/app-store/store'
import axios, { AxiosError } from 'axios'

export class AuthService {
  static async getAccessToken(): Promise<string | null> {
    if (AUTH_MODE === 'keycloak') {
      if (keycloakAuthService().isAuthenticated()) {
        await keycloakAuthService().ensureFreshToken(30) // ensure token is fresh
        const token = keycloakAuthService().getAccessToken()
        return token ?? null
      } else {
        return null
      }
    } else {
      const { access_token } = store.getState().auth // Redux state
      return access_token ?? null
    }
  }

  static logout(): void {
    store.dispatch(legacyLogout())
    if (AUTH_MODE === 'keycloak') {
      keycloakAuthService().logout()
    }
  }

  static async handleAuthError(error: AxiosError) {
    const status = error.response?.status
    if (
      AUTH_MODE === 'keycloak' &&
      (status === 401 || status === 403) &&
      keycloakAuthService().isAuthenticated()
    ) {
      try {
        await keycloakAuthService().ensureFreshToken(0)

        const cfg = error.config
        if (cfg) {
          cfg.headers = cfg.headers || {}
          const token = keycloakAuthService().getAccessToken()
          if (token) cfg.headers.Authorization = `Bearer ${token}`
          return axios(cfg)
        }
      } catch {
        keycloakAuthService().login()
        return
      }
    }
    throw error
  }
}
